import { render } from "./Gallery.vue?vue&type=template&id=5a559752"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=5a559752&lang=css"

import exportComponent from "/Users/andrewdrury/Desktop/code/website/altPhoto/photography/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__